import { trackCustomEvent } from './src/utils/googleAnalytics';

const linkLocation = (link) => {
  if (link.closest('nav')) return 'header';
  if (link.closest('footer')) return 'footer';
  if (link.closest('[data-quote-form]')) return 'form';
  return 'body';
};

// Gatsby browser APIs must be named exports.
// eslint-disable-next-line import/prefer-default-export
export const onClientEntry = () => {
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
    if (!link) return;
    const pagePath = window.location.pathname;
    if (link.getAttribute('href').startsWith('tel:')) {
      trackCustomEvent('phone_click', { page_path: pagePath, location: linkLocation(link) });
    } else {
      trackCustomEvent('email_click', { page_path: pagePath });
    }
  });
};
